import React, { useEffect } from "react";
import { Subscribe } from "../../../../packages/ui/features/payments/src/Subscribe";
import { toast } from "@jammable/ui-core";
import { useModal } from "@/context/ModalContext";

const UpgradeModal = ({ message = "", from, dailyLimit = false }) => {
  const { closeModal } = useModal();

  return (
    <div>
      <Subscribe
        hasSidebar={dailyLimit ? true : false}
        renderCheckout={true}
        message={message}
        callback={() => {
          toast.success("You have subscribed!");
          closeModal("upgrade-modal");
        }}
        from={from}
      />
    </div>
  );
};

export default UpgradeModal;
